import { DateTimeType } from "../../typings";
import { dateOptions, yearOptions, time12Options, time24Options, monthNameText, dateOptionsNumeric } from "../../constants";
import { getCurrentTime, DateFromISO } from "../../dependencies";
DateFromISO();
const dateTimeYearOptionsMap = {
    format12Hour: Object.assign(Object.assign(Object.assign({}, dateOptions), yearOptions), time12Options),
    format24Hour: Object.assign(Object.assign(Object.assign({}, dateOptions), yearOptions), time24Options),
    none: Object.assign(Object.assign(Object.assign({}, dateOptions), yearOptions), time24Options)
};
const dateOptionsMap = {
    format12Hour: Object.assign({}, dateOptions),
    format24Hour: Object.assign({}, dateOptions),
    none: Object.assign({}, dateOptions)
};
const timeOptionsMap = {
    format12Hour: Object.assign({}, time12Options),
    format24Hour: Object.assign({}, time24Options),
    none: Object.assign({}, time24Options)
};
let formatCallback;
export const buildDateTimeFormatter = (type, hourOptions, useMonthName, useFullDate, getDateTimeFormatter, overrideOptions = false) => {
    let options = {};
    if (type === DateTimeType.time) {
        options = timeOptionsMap[hourOptions];
    }
    else {
        options = Object.assign(Object.assign({}, getInitialDateFormat(useFullDate, hourOptions)), getMonthOptions(useMonthName));
    }
    if (!formatCallback || overrideOptions) {
        formatCallback = formatIsoDateTime.bind(undefined, getDateTimeFormatter(options));
    }
    return formatCallback;
};
function getInitialDateFormat(useFullDate, hourOptions) {
    return useFullDate ? dateTimeYearOptionsMap[hourOptions] : dateOptionsMap[hourOptions];
}
function getMonthOptions(useMonthName) {
    return useMonthName ? monthNameText : dateOptionsNumeric;
}
function formatIsoDateTime(formatter, isoDateTime, timeZone) {
    const currentDateTime = Date.fromISO(isoDateTime);
    if (!currentDateTime) {
        return "";
    }
    const dateTime = getCurrentTime(currentDateTime, timeZone);
    return formatter.format(dateTime);
}
//# sourceMappingURL=buildDateTimeFormatter.js.map